import { authApiService } from '@/api/authApiService';
import { ApiParams } from '@/api/helpers/apiHelpers';
import { ApiResponseType, ListResponseType } from '@/types/sharedTypes';
import { WireAssignedType } from '@/types/wireTypes';

export type InternalOrganizationBillingEventType = {
  id: string;
  date_created: string;
  is_kyc_required: boolean;
  user: {
    email: string;
    id: string;
  };
  wire: {
    id: string;
    name: string;
    ref_id: string;
    type: WireAssignedType;
    contract: {
      id: string;
      name: string;
    };
  };
};

export const getInternalOrganizationBillingEventsApi = async (
  params?: ApiParams
): Promise<ApiResponseType<ListResponseType<InternalOrganizationBillingEventType>>> => {
  const uri = '/organization/internal/events/wire/';

  return authApiService.GET(uri, params);
};
